module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/window-curtain/window.mtl";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/window-curtain/window.mtl
// module id = 499
// module chunks = 0